import React from "react";
import PropTypes from "prop-types";

const generateFormHtml = (actionUrl, embedToken) =>
	`
    <!DOCTYPE html>
    <html>
        <head>
            <meta 
                http-equiv="Content-Security-Policy"
                content="upgrade-insecure-requests"
            />
        </head>
        <body>
            <form id="embedForm" action="${actionUrl}" method="post" target="embedFrame">
                <input type="hidden" name="embedToken" value="${embedToken}" />
            </form>
            <script>
                        document.getElementById("embedForm").submit();
            </script>
        </body>
    </html>
    `;

const generateDataUri = html => `data:text/html;charset=utf-8,${encodeURI(html)}`;

const ReportEmbedder = ({ embedKey }) => {
	const actionUrl = embedKey.split("?embedToken=")[0];
	const embedToken = embedKey.split("?embedToken=")[1];
	const htmlContent = generateFormHtml(actionUrl, embedToken);
	const formDataUri = generateDataUri(htmlContent);

	return (
		<iframe
			className="panel embed-panel"
			name="embedFrame"
			src={formDataUri}
			title="embedFrame"
		/>
	);
};

ReportEmbedder.propTypes = {
	embedKey: PropTypes.string,
};

ReportEmbedder.defaultProps = {
	embedKey: "",
};

export default ReportEmbedder;
